(ns machtfit.product-form.review
  (:require
   [re-frame.core :as rf]))

(def changeable-fields
  ;; Sections in the product form do not always
  ;; correspond to the same outer keys in the product data dictionary
  ;; e.g. the :when section holds the input for [:how-much :number-of-appointments].
  ;; Hence, we specify the full paths as keys here
  ;; and cannot just use the section key for the lookup.
  {:what {[:what :title] "Titel"
          [:what :description] "Beschreibung"
          [:what :image-id] "Bild-ID"
          [:what :images] "Produktbilder"
          [:what :video-url] "Video-URL"
          [:what :activity-type] "Aktivitätstyp"
          [:what :category] "Kategorie"
          [:what :website] "Webseite"
          [:what :promoted?] "Hervorgehoben?"
          [:what :source-type] "Quelltyp"
          [:what :source-id] "Quellen-ID"
          [:what :source-url] "Quellen-URL"
          [:what :source-retrieved] "Quelle abgerufen"
          [:what :sorting-number] "Sortiernummer"
          [:what :bookable?] "Buchbar?"
          [:what :labels] "Labels"
          [:what :content-sections] "Ausklappbarer Inhalt"
          [:what :faqs] "FAQs"
          [:what :wellhub-promotion?] "Wellhub-Promotion?"
          [:what :key-facts] "Schlüsselfakten"
          [:what :search-keywords] "Schlagwörter"}
   :when {[:when :unit-duration] "Termindauer"
          [:when :registration-deadline-relative] "Registrierungs-Deadline"
          [:when :sessions-per-signup] "Termine pro Anmeldung"
          [:when :cohesion] "Aufbauende Termine"
          [:when :offer-list-deadline] "Angebotslisten-Deadline"
          [:when :has-schedule?] "termingebunden?"
          [:when :schedules] "Kursplan"
          [:when :slots] "Anzahl Termine"
          [:when :weekdays] "Wochentage"
          [:how-much :number-of-appointments] "Anzahl Termine"}
   :for-whom {[:for-whom :audience-gender] "Geschlecht"
              [:for-whom :audience-age] "Alter"
              [:for-whom :allowed-employees] "Mitarbeitende"
              [:for-whom :area-independent-access] "Zugriff ortsunabhängig"
              [:for-whom :max-participants] "Max. Teilnehmer"
              [:for-whom :min-participants] "Min. Teilnehmer"
              [:for-whom :bookable-only-once?] "Nur einmal buchbar?"}
   :where {[:where :address] "Adresse"
           [:where :is-open-despite-corona?] "Trotz Corona geöffnet?"
           [:where :location-type] "Ortstyp"
           [:where :is-app?] "ist eine App"
           [:where :is-stream?] "wird gestreamt"
           [:where :usage-description] "Nutzungsbeschreibung"
           [:what :website] "Webseite"}
   :who {[:who :certificate-id] "Zertifikat"
         [:what :p20-certified?] "P20-zertifiziert?"}
   :how {[:how :access-codes] "Zugangscodes"
         [:how :access-codes-warning-threshold] "Zugangscode-Warnschwelle"
         [:how :registration-type] "Anmeldungstyp"
         [:how :require-user-info] "Benutzerinfo erforderlich?"
         [:how :user-info-explanation-text] "Erklärungstext Benutzerinfo"
         [:how :extra-info-fields] "Zusätzliche Infofelder"
         [:how :registration-url] "Anmelde-URL"
         [:how :registration-needed?] "Anmeldung erforderlich?"
         [:how :needs-access-code?] "Zugangscode notwendig?"
         [:how :participant-instructions] "Hinweise"}
   :how-much {[:how-much :validity-period] "Gültigkeitszeitraum"
              [:how-much :commission] "Provision"
              [:how-much :subsidies] "Zuschüsse"
              [:how-much :price-given?] "Preis angegeben?"
              [:how-much :amount] "Preis"
              [:how-much :suggested-retail-price] "UVP"
              [:how-much :vat] "MwSt"
              [:how-much :max-bookings] "Max. Buchungen"}})

(def colors
  {"changed" "#B5F2FF"
   "added" "#ACEEBB"
   "removed" "#FFCECB"})

(rf/reg-sub ::change-for-field
  :<- [:get [:changes]]
  (fn [changes [_ path]]
    (get-in changes path)))

(rf/reg-sub ::style-for-field
  :<- [:get [:changes]]
  (fn [changes [_ path]]
    (when-let [change-type (get-in changes path)]
      {:background-color
       (get colors change-type (get colors "changed"))})))

(rf/reg-sub ::style-for-section
  :<- [:get [:changes]]
  (fn [changes [_ section-key]]
    (when (seq (get changes section-key))
      {:background-color (get colors "changed")})))

(defn highlighted-field-span [path text]
  [:span {:style @(rf/subscribe [::style-for-field path])} text])

(defn highlighted-section-title [key text]
  [:span {:style @(rf/subscribe [::style-for-section key])} text])

(defn- field-badge [section path]
  (when-let [change-type @(rf/subscribe [::change-for-field path])]
    [:li
     [:a.review-label
      {:key (str path)
       :href @(rf/subscribe [:get [:ui :admin-productlog-changelist-url]])
       :target "_blank"
       :style {:background-color (get colors change-type (get colors "changed"))
               :color "black"}}
      (get-in changeable-fields [section path])]]))

(defn field-badges [section]
  [:ul.nav.nav-pills
   (for [change-path (keys (get changeable-fields section))]
     ^{:key change-path}
     [field-badge section change-path])])
